var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSocial4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.889 5.556H15.767C15.267 4.689 14.578 3.945 13.744 3.378L15.555 1.567L13.989 0L11.578 2.412C11.067 2.289 10.545 2.222 10 2.222C9.45602 2.222 8.93302 2.289 8.43402 2.412L6.01102 0L4.44402 1.567L6.24402 3.378C5.42202 3.945 4.73302 4.689 4.23402 5.556H1.11102V7.778H3.43402C3.37802 8.145 3.33302 8.511 3.33302 8.889V10H1.11102V12.222H3.33302V13.333C3.33302 13.711 3.37802 14.078 3.43402 14.444H1.11102V16.667H4.23402C5.38902 18.655 7.53302 20 10 20C12.467 20 14.611 18.655 15.767 16.667H18.889V14.444H16.567C16.622 14.078 16.667 13.711 16.667 13.333V12.222H18.889V10H16.667V8.889C16.667 8.511 16.622 8.145 16.567 7.778H18.889V5.556ZM12.222 14.444H7.77802V12.222H12.222V14.444ZM12.222 10H7.77802V7.778H12.222V10Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocial4);
export default __webpack_public_path__ + "static/media/social4.8cdb33fd.svg";
export { ForwardRef as ReactComponent };